import {ValidatorProvider} from '@dofleini/validator';
import {Form} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

import {CACHE_KEY_LIST_ORGANIZATION} from '@/modules/configuration/contants/organization';
import OrganizationApiService from '@/modules/configuration/services/OrganizationApiService';
import SelectElementCmp from '@/utils/SelectElementCmp';

import style from './index.less';

const OrganizationSelect = ({value, onChange, filters, ...props}) => {
  const {t} = useTranslation('common');
  const currentValue = value && typeof value === 'object' ? value._id : value;

  return (
    <>
      <div className={classNames('w-full', style.container)}>
        <SelectElementCmp
          {...props}
          queryKey={CACHE_KEY_LIST_ORGANIZATION}
          filters={filters}
          service={OrganizationApiService}
          includeValue={value}
          value={currentValue}
          placeholder={t('selectPlaceholder')}
          onChange={onChange}
          queryConfig={{refetchOnWindowFocus: false}}
        />
      </div>
    </>
  );
};

OrganizationSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  showContact: PropTypes.bool,
  filters: PropTypes.object
};

export default memo(OrganizationSelect);

export const renderOrganizationSelect = ({formItemProps, field, form}) => {

  const rules = field?.required && [{required: true, message: ValidatorProvider.t('validateMessages.required')}];

  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <OrganizationSelect {...field?.widgetProps} {...field} form={form}/>
    </Form.Item>
  );
};
